import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

function Chiesa(props) {
  const { specialMsg } = props;
  let msg = "Santuario Basilica del Sacro Cuore di Gesu'";
  if (specialMsg) {
    msg =
      "Grazie per la risposta! Ci vediamo il 27 giugno alle ore 15:30 in Piazza Don Francesco Lombardi, 18038 Bussana IM";
  }
  return (
    <Card sx={{ backgroundColor: "transparent" }}>
      {specialMsg ? null : (
        <CardMedia
          component="image"
          sx={{ height: 640 }}
          image="chiesa.jpg"
          title="Santuario Basilica del Sacro Cuore di Gesù"
        />
      )}
      <CardContent sx={{ backgroundColor: "transparent" }}>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          sx={{
            fontFamily: '"Penna"',
            fontSize: "1.8rem",
            color: "#FFF",
            fontWeight: "bold",
          }}
        >
          {msg}
        </Typography>
        {specialMsg ? null : (
          <>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontFamily: '"Penna"',
                fontSize: "1.8rem",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              Indirizzo: Piazza Don Francesco Lombardi, 18038 Bussana IM
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{
                fontFamily: '"Penna"',
                fontSize: "1.8rem",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              Inizio cerimonia alle ore 15:30 <br />
              👰🤵
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
}

export default Chiesa;
